import React from 'react';
import { Lock } from 'lucide-react';
import { STEP_TITLES, STEP_ICONS, STEP_COMING_SOON_TEXT } from '../constants';

/**
 * Locked "Kommer snart" placeholder for the wizard steps that ship in
 * later phases (P1 only builds Förberedelser + Stäm av kontona).
 * Rendered inside the step modern-card; the ye-badge chrome comes from
 * YearEndPage.
 */
const PlaceholderStep = ({ step }) => {
    const Icon = STEP_ICONS[step];

    return (
        <>
            <style>{`
                .ye-placeholder {
                    text-align: center;
                    padding: 3rem 1.5rem;
                }
                .ye-placeholder-icon {
                    position: relative;
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    background: #f3f4f6;
                    color: #9ca3af;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 1rem;
                }
                .ye-placeholder-lock {
                    position: absolute;
                    bottom: -2px;
                    right: -2px;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    background: white;
                    border: 1px solid #e5e7eb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #9ca3af;
                }
                .ye-placeholder-title {
                    font-size: 1.125rem;
                    font-weight: 600;
                    color: var(--title, #374151);
                    margin-bottom: 0.5rem;
                }
                .ye-placeholder-text {
                    max-width: 58ch;
                    margin: 1rem auto 0;
                    font-size: 0.875rem;
                    line-height: 1.6;
                    color: #6b7280;
                }
            `}</style>

            <div className="modern-card-body">
                <div className="ye-placeholder">
                    <div className="ye-placeholder-icon">
                        {Icon ? <Icon size={26} /> : <Lock size={26} />}
                        <span className="ye-placeholder-lock">
                            <Lock size={12} />
                        </span>
                    </div>

                    <div className="ye-placeholder-title">
                        {STEP_TITLES[step] || step}
                    </div>
                    <span className="ye-badge ye-badge-warning">Kommer snart</span>

                    <p className="ye-placeholder-text">
                        {STEP_COMING_SOON_TEXT[step]
                            || 'Det här steget är inte tillgängligt ännu — det öppnas i en kommande version.'}
                    </p>
                </div>
            </div>
        </>
    );
};

export default PlaceholderStep;
